import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLeadForm } from '../../../contexts/LeadFormContext';

const ClientTestimonials = ({ testimonials }) => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [playingVideo, setPlayingVideo] = useState(null);

  const handlePrevTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === 0 ? testimonials?.length - 1 : prev - 1
    );
    setPlayingVideo(null);
  };

  const handleNextTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === testimonials?.length - 1 ? 0 : prev + 1
    );
    setPlayingVideo(null);
  };

  const handleVideoPlay = (index) => {
    setPlayingVideo(index);
  };

  // handleWhatsAppContact removido - usando contexto de lead form

  const current = testimonials?.[currentTestimonial];

  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-lg">
      {/* Header */}
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Icon name="MessageSquare" size={24} color="var(--color-primary)" />
            <h3 className="font-playfair font-bold text-xl text-text-primary">
              Depoimentos dos Clientes
            </h3>
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={handlePrevTestimonial}
              className="w-8 h-8 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-colors duration-200"
            >
              <Icon name="ChevronLeft" size={16} />
            </button>
            <span className="text-sm text-text-secondary">
              {currentTestimonial + 1} / {testimonials?.length}
            </span>
            <button
              onClick={handleNextTestimonial}
              className="w-8 h-8 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-colors duration-200"
            >
              <Icon name="ChevronRight" size={16} />
            </button>
          </div>
        </div>
      </div>
      {/* Testimonial Content */}
      <div className="p-6">
        <div className="grid lg:grid-cols-2 gap-6">
          {/* Video/Image Section */}
          <div className="space-y-4">
            {/* Main Video/Image */}
            <div className="relative rounded-xl overflow-hidden">
              {current?.videoUrl && playingVideo === currentTestimonial ? (
                <video
                  src={current?.videoUrl}
                  controls
                  autoPlay
                  className="w-full h-64 object-cover"
                  onEnded={() => setPlayingVideo(null)}
                />
              ) : (
                <div className="relative">
                  <Image
                    src={current?.homeImage}
                    alt={`Casa de ${current?.name}`}
                    className="w-full h-64 object-cover"
                  />
                  {current?.videoUrl && (
                    <button
                      onClick={() => handleVideoPlay(currentTestimonial)}
                      className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/50 transition-colors duration-200 group"
                    >
                      <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                        <Icon name="Play" size={24} color="white" />
                      </div>
                    </button>
                  )}
                  {current?.videoUrl && (
                    <div className="absolute top-4 right-4 px-2 py-1 bg-black/70 text-white text-xs rounded">
                      <Icon name="Video" size={12} className="inline mr-1" />
                      Vídeo
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Additional Images */}
            <div className="grid grid-cols-3 gap-2">
              {current?.additionalImages?.map((image, index) => (
                <div key={index} className="relative rounded-lg overflow-hidden">
                  <Image
                    src={image}
                    alt={`Ambiente ${index + 1}`}
                    className="w-full h-20 object-cover"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Testimonial Text */}
          <div className="space-y-4">
            {/* Client Info */}
            <div className="flex items-center space-x-4">
              <Image
                src={current?.avatar}
                alt={current?.name}
                className="w-16 h-16 rounded-full object-cover"
              />
              <div>
                <h4 className="font-semibold text-lg text-text-primary">
                  {current?.name}
                </h4>
                <p className="text-text-secondary">{current?.title}</p>
                <p className="text-text-secondary text-sm">{current?.location}</p>
              </div>
            </div>

            {/* Rating */}
            <div className="flex items-center space-x-2">
              <div className="flex items-center space-x-1">
                {[...Array(5)]?.map((_, i) => (
                  <Icon
                    key={i}
                    name="Star"
                    size={16}
                    color={i < current?.rating ? "var(--color-accent)" : "var(--color-border)"}
                    strokeWidth={0}
                    className="fill-current"
                  />
                ))}
              </div>
              <span className="text-sm text-text-secondary">
                {current?.rating}/5 estrelas
              </span>
            </div>

            {/* Testimonial Text */}
            <blockquote className="text-text-primary leading-relaxed">
              <Icon name="Quote" size={20} color="var(--color-primary)" className="mb-2" />
              {current?.testimonial}
            </blockquote>

            {/* Project Details */}
            <div className="bg-muted rounded-lg p-4 space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-text-secondary">Projeto:</span>
                <span className="font-medium text-text-primary">{current?.projectType}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-text-secondary">Investimento:</span>
                <span className="font-medium text-text-primary">{current?.investment}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-text-secondary">Duração:</span>
                <span className="font-medium text-text-primary">{current?.duration}</span>
              </div>
            </div>

            {/* Action Button */}
            <Button
              variant="outline"
              fullWidth
              iconName="MessageCircle"
              iconPosition="left"
              onClick={openLeadForm}
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
            >
              Conversar sobre Projeto Similar
            </Button>
          </div>
        </div>
      </div>
      {/* Navigation Dots */}
      <div className="px-6 pb-6">
        <div className="flex items-center justify-center space-x-2">
          {testimonials?.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setCurrentTestimonial(index);
                setPlayingVideo(null);
              }}
              className={`w-2 h-2 rounded-full transition-colors duration-200 ${
                index === currentTestimonial
                  ? 'bg-primary' :'bg-border hover:bg-primary/50'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientTestimonials;